import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import DownloadsListHeader from './ListHeader';
import DownloadsListItem from './ListItem';
import EmptyDownloads from '../../containers/EmptyContainers/Downloads';

const DownloadsList = ({
  downloads,
  loadDownloads,
  ...props
}) => (
  <>
    {downloads.length > 0 ? (
      <div className="table-wrapper">
        <Table className="users-list downloads-list files-list" responsive>
          <thead>
            <DownloadsListHeader
              {...props}
            />
          </thead>
          <tbody>
            {downloads.map(download => (
              <DownloadsListItem
                key={download.uuid}
                download={download}
                loadDownloads={loadDownloads}
              />
            ))}
          </tbody>
        </Table>
      </div>
    ) : (
      <EmptyDownloads />
    )}
  </>
);

DownloadsList.propTypes = {
  downloads: PropTypes.array.isRequired,
  loadDownloads: PropTypes.func.isRequired,
};

export default DownloadsList;
